import type { V2CreateAdminProjectInput } from '@idc-forms/schemas/api-v2/admin-projects'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateProjectV2Mutation } from '../hooks/use-project-v2-mutations'
import { ProjectV2Form } from './project-v2-form'

type ProjectV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo proyecto" contra la API v2: el mismo `ProjectV2Form` que la edición. */
export function ProjectV2CreatePanel({ onDone }: ProjectV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateProjectV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminProjectInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <ProjectV2Form
      submitLabel="Crear proyecto"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
